/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type ScriptTypeEnum = 'PYTHON' | 'BASH';

export const ScriptTypeEnum = {

    PYTHON: 'PYTHON' as ScriptTypeEnum,

    BASH: 'BASH' as ScriptTypeEnum
};

